module.exports = __webpack_public_path__ + "img/wallet.3db1b672.svg";